<span *ngIf="pill" class="fo-pill" [ngClass]="'fo-pill--' + pill.tone" [class.fo-pill--small]="small" data-test="fiscal-status-pill">{{ pill.label }}</span>
